export const CERTIFICATE_TYPES = [
  { id: "CME", value: "CME", label: "CME" },
  { id: "CE", value: "CE", label: "CE" },
  { id: "MEDBLEND", value: "MEDBLEND", label: "MEDBLEND" }
];

export const MATERIAL_TYPES = [
  { id: 0, value: "Video", label: "Video" },
  { id: 1, value: "Image", label: "Image" }
  // { id: 2, value: "DICOM", label: "DICOM" }
];

export const SUPPORTED_IMAGES_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/tiff"
];

export const ASC = "ASC";
export const DESC = "DESC";

export const getFullCloudFrontURL = (mediaPath) => {
  if (!mediaPath) return "";

  // If it's already a full URL, return as-is
  if (
    mediaPath.startsWith("http://") ||
    mediaPath.startsWith("https://") ||
    mediaPath?.startsWith("blob") ||
    mediaPath.startsWith("data:")
  ) {
    return mediaPath;
  }
  return process.env.REACT_APP_CLOUDFRONT_URL + "/" + mediaPath;
};

export const getFullPublicURL = (mediaPath) => {
  if (!mediaPath) return "";

  // If it's already a full URL, return as-is
  if (
    mediaPath.startsWith("http://") ||
    mediaPath.startsWith("https://") ||
    mediaPath?.startsWith("blob") ||
    mediaPath.startsWith("data:")
  ) {
    return mediaPath;
  }
  return process.env.REACT_APP_PUBLIC_S3_S3URL + "/" + mediaPath;
};

// at first sure that src is not null , local blob or not then get the local public
export const getLocalORPublicSrc = (src) =>
  src
    ? src?.startsWith("blob") || src.startsWith("data:")
      ? src
      : getFullPublicURL(src)
    : "";

export const DIFFIECULTY_LEVEL_LIST = [
  { id: "easy", name: "Easy" },
  { id: "hard", name: "Hard" },
  { id: "medium", name: "Medium" }
];

export const MODE_ELIGIBILITY = [
  { id: "all_modes", name: "All Modes" },
  { id: "memory_only", name: "Memory Trainer" }
];
